import { cn } from "~/utils";
import { Avatar, AvatarFallback, AvatarImage } from "~/components/ui/avatar";

interface ProfilePictureProps {
  className?: string;
  name?: string | null;
  photoUrl?: string | null;
  avatarClassName?: string;
}

export function ProfilePicture({
  name,
  photoUrl,
  className,
  avatarClassName,
}: ProfilePictureProps) {
  return (
    <Avatar className={cn("h-10 w-10", className)}>
      <AvatarImage src={photoUrl ?? ""} className={avatarClassName} />
      <AvatarFallback
        className={cn("uppercase font-semibold", avatarClassName)}
      >
        {name?.[0]}
      </AvatarFallback>
    </Avatar>
  );
}
